import Vue from 'vue'
import Vuex from 'vuex'
import Auth from 'utils/auth.js';
import { UPDATEUSER, UPDATETOKEN } from './mutation-type.js';

Vue.use(Vuex);




export default new Vuex.Store({
  state: {
    user: '',
    tokens: ''
  },
  mutations: {
    [UPDATEUSER](state, data){
      state.user = data;
    },
    [UPDATETOKEN](state, data){
      state.tokens = data;
    }
  },
  actions: {
    cbgcAuth(context,payload){
      // console.log('payload:', payload);
      return new Promise((resolve, reject) => {
        let tempData = {
          cacheName: 'cbgcAuth',
          type: context.state.user ? 'token' : '',
          refresh: 0
        }
        payload && payload.cacheName && (tempData.cacheName = payload.cacheName);
        payload && payload.refresh && (tempData.refresh = payload.refresh);
        payload && payload.type && (tempData.type = payload.type);
        Auth(tempData).then(res=>{
          console.log('action auth res:', res);
          if(res.status !== 'validEnv'){
            (!context.state.user || tempData.refresh) && res.user && context.commit(UPDATEUSER, res.user);
            (!context.state.tokens || tempData.refresh) && context.commit(UPDATETOKEN, res.meta ? res.meta.custom : res.access_token);
          }
          resolve(res);
        }).catch(err=>{
          console.log('store err:', err);
          reject(err);
        });
      });
    },
    clearAuth(context, payload){
      context.commit(UPDATEUSER, '');
      context.commit(UPDATETOKEN, '');
    }
  },
  modules: {
  }
})
